import React, { useState } from "react";
import "./TextAreaInput.css"
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const TextAreaInput = ({
  label,
  name,
  value = "",
  onChange,
  parentClassName = "",
  inputClassName = "",
  labelClassName = "",
  placeholder = "Enter text area",
  parentStyle = {},
  inputStyle = {},
  labelStyle = {},
  rows = 3,
  cols = 10,
  maxLength,
  minLength,
  readOnly = false,
  disabled = false,
  required = false,
  wrap = "soft",
  customError,
  asterisk,
}) => {
  const handleInputChange = (event) => {
    onChange(event);
  };

  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-textarea-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-textarea-label-class"
        }
        style={labelStyle}>
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="textarea-input-wrapper">
        <textarea
          name={name}
          type="textarea"
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
          className={`${
            inputClassName && inputClassName.trim() !== ""
              ? inputClassName
              : "default-textarea-input-class"
          } ${customError ? "textarea-input-error" : ""}`}
          style={{
            ...inputStyle, // Any other custom styles you want to pass
            backgroundColor: disabled || readOnly ? "lightgray" : "", // Set background color to light gray if disabled
          }}
          rows={rows}
          cols={cols}
          maxLength={maxLength}
          minLength={minLength}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          wrap={wrap}
        />

        {customError && (
          <i className="fas fa-exclamation-circle textarea-error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};
export default TextAreaInput
